module.exports = __webpack_public_path__ + "static/media/sonomeazul.6d19d292.png";